import React from "react";
import { Card } from "semantic-ui-react";
import BCButton from "./BCButton";
import "../../styles/landing-page.scss";
import "../../styles/main.scss";
import { css } from "@emotion/css";
import BCCard from "./BCCard";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";

interface BPProps {
    isGreaterThanMobile?;
    infoData;
    handleInfo?;
    displayList; 
    handleExport?;
    handleApplication?;
    handleCopyApplication?;
    handleSummary?;
    handleGMR?;
    handleCopyGMR?;
    ellipsis?;
    labels?;
    permissions?;
    isKanban?;
    brokerColor?;
    disableSummary?;
    disableApplication?;
    ellipsisHandlers?;
}

const BCCards = ({ ...props }: BPProps) => {
  const brokerCardOverrideCSS = css`
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 ${(props.brokerColor && getIsWhiteLabeled()) ? props.brokerColor : "black"}, 0 1px 3px 0 #d4d4d5 !important;
  `;

  return (
    <Card.Group className={props.isGreaterThanMobile ? "landing-page-cards" : "landing-page-cards landing-page-cards-mobile"}>
      {props.isGreaterThanMobile && props.isKanban === false && <Card className="landing-page-card landing-page-card-grow" onClick={props.handleInfo}>
        <Card.Content className={(props.brokerColor && getIsWhiteLabeled()) ? brokerCardOverrideCSS :"landing-page-card-content-first"}>
          <Card.Description className="landing-page-card-first vertical-center">
            <div className="landing-page-card-first-text">Take a first step and begin your next project with Builders Capital</div>
            <div className="landing-page-card-first-button">
              <BCButton labelPosition="left" iconName="add" brokerColor={props.brokerColor} handleOnClick={() => props.handleInfo}>
                {props.handleInfo === props.handleGMR ? <div>Start Pricing</div> : <div>Start Application</div>}
              </BCButton>
            </div>
          </Card.Description>
        </Card.Content>
      </Card>}
      {props.infoData && props.displayList.map((item, i) => {
        let isSummary = true;
        let isApplication = true;
        if (props.disableSummary && ["New", "Sent"].indexOf(item.statusLookupName) > -1) {
          isSummary = false;
        }
        
        if (props.disableApplication && ["Revision", "Submitted"].indexOf(item.statusLookupName) > -1) {
          isApplication = false;
        }

        return (
            <BCCard
              key={`bc-card-${i}`}
              isGreaterThanMobile={props.isGreaterThanMobile}
              infoData={props.infoData}
              handleInfo={props.handleInfo}
              displayList={props.displayList} 
              handleExport={props.handleExport}
              handleApplication={props.handleApplication}
              isApplication={isApplication}
              handleCopyApplication={props.handleCopyApplication}
              handleSummary={props.handleSummary}
              isSummary={isSummary}
              handleGMR={props.handleGMR}
              handleCopyGMR={props.handleCopyGMR}
              ellipsis={props.ellipsis}
              labels={props.labels}
              permissions={props.permissions}
              isKanban={props.isKanban}
              brokerColor={props.brokerColor}
              item={item}
              i={i}
              ellipsisHandlers={props.ellipsisHandlers}
            />
        );
      })}
    </Card.Group>
  ); 
};

export default BCCards;